import { ReactNode } from 'react';
import { modals } from '@mantine/modals';
import {
  BareModalOptions,
  FormModalLabelFooterOptions,
  openFormModal,
} from './modal';
import { MeaningIcons } from '@/lib/data/meaningIcons';

export interface ConfirmationModalOptions
  extends BareModalOptions,
    FormModalLabelFooterOptions {
  message: string | ReactNode;
  onConfirm?: () => void;
}

/**
 * Opens a confirmation modal with a body section and confirm/cancel buttons.
 */
export const openConfirmationModal = ({
  message,
  onConfirm,
  meaning = 'default',
  icon = MeaningIcons[meaning],
  title = 'Confirm',
  submitLabel = 'OK',
  cancelLabel = 'Cancel',
  ...props
}: ConfirmationModalOptions) => {
  const formId = openFormModal({
    ...props,
    bodySection: typeof message === 'string' ? <p>{message}</p> : message,
    onSubmitHandler: (event) => {
      event.preventDefault();
      onConfirm?.();
      modals.close(formId);
    },
    meaning,
    icon,
    title,
    submitLabel,
    cancelLabel,
    withCloseButton: false,
  });
  return formId;
};

export const waitForConfirmationModal = ({
  ...props
}: Omit<ConfirmationModalOptions, 'onConfirm'>) =>
  new Promise<void>((resolve) =>
    openConfirmationModal({
      ...props,
      onConfirm: () => resolve(),
    })
  );
